import React from 'react'
import { Card } from 'react-bootstrap'
import './dashboardCard.css'
import { UtilisationPeriod } from '../../../../back-end/common/billyDashboard'
import { isUtilisationPeriod } from '../../constants/utilisation'

export type DashboardCardBGColor = 'navy' | 'royal-blue' | 'cornflower' | 'green' | 'salmon' | 'lavender'

const periodToColor = (period: UtilisationPeriod): DashboardCardBGColor => {
	switch (period) {
		case 'week':
			return 'royal-blue'
		case 'month':
			return 'green'
		case 'year':
			return 'salmon'
	}
}

const DashboardCard = ({ background, children }: { background: DashboardCardBGColor | UtilisationPeriod; children: React.ReactNode }) => (
	<Card className={`dashboard-card ${isUtilisationPeriod(background) ? periodToColor(background) : background}`}>{children}</Card>
)

const HeaderBr = ({ color }: { color: 'black' | 'white' }) => <div className={`header-${color}`} />

export default DashboardCard
export { HeaderBr, periodToColor }
